import { useContext } from "react"

import { NotificationContactsActionsContext } from "../../../components/Randomization/Notification/NotificationContactsProvider"

export const useNotificationContactsActions = () => {
  const notificationContactsActionsContext = useContext(NotificationContactsActionsContext)

  if (!notificationContactsActionsContext) {
    throw new Error("useNotificationContacts must be used within a NotificationContactsActionsProvider")
  }

  return notificationContactsActionsContext
}
